import { Controller } from "stimulus";
import { formatCurrency } from "../../util/currency";
import {chartTranslations} from "../../config";

export default class extends Controller {
  connect() {
    this.drawBubbleChart();
  }

  drawBubbleChart() {
    Promise.all([
      import("highcharts"),
      import("highcharts/highcharts-more")
    ]).then(res => {
      const Highcharts = res[0];
      Highcharts.setOptions({ lang: { ...chartTranslations() } });

      const HighchartsMore = res[1].default;
      HighchartsMore(Highcharts);
      const bubbleChartData = JSON.parse(this.element.dataset.coinsBubbleChartData);

      var chartHeight;
      if (JSON.parse(this.element.getAttribute("data-auto-height"))) {
        chartHeight = $(window).height() - 150;
      } else {
        chartHeight = 0;
      }


      Highcharts.chart('coins-bubble-chart', {
        chart: {
            type: 'packedbubble',
            height: `${chartHeight}px`
        },
        credits: {
          enabled: false
        },
        title: {
            text: this.element.getAttribute("data-title")
        },
        tooltip: {
          useHTML: true,
          formatter: function() {
            var changeHTML;
            if (this.point.priceChangePercentage24h > 0) {
              changeHTML = `<span style="color:#5D8456;font-weight:700;">${parseFloat(
                this.point.priceChangePercentage24h
              ).toFixed(2)}%</span>`;
            } else {
              changeHTML = `<span style="color:#B94A45;font-weight:700;">${parseFloat(
                this.point.priceChangePercentage24h
              ).toFixed(2)}%</span>`;
            }

            return [
              "<div>",
              '<div style="font-weight:700;">',
              `<img style="width:20px; margin-right:5px;" src="${this.point.coinImageUrl}">`,
              `<span>${this.point.coinName}</span>`,
              "</div>",
              "<br>",
              `<div>${I18n.t("charts.price")}: ${formatCurrency(this.point.price, "usd", false)}</div>`,
              `<div>${I18n.t("charts.24h_change")}: ${changeHTML}</div>`,
              `<div>${I18n.t("charts.market_cap")}: ${formatCurrency(this.point.value, "usd", false)}</div>`,
              "</div>"
            ].join("");
          },
          style: {
            textAlign: "center",
            fontSize: "1rem"
          }
        },
        plotOptions: {
          packedbubble: {
            useSimulation: false,
            minSize: '40%',
            zMin: 0,
            zMax: 1000,
            layoutAlgorithm: {
              splitSeries: false,
              gravitationalConstant: 0.02
            },
            dataLabels: {
              useHTML: true,
              enabled: true,
              style: {
                textAlign: "center"
              },
              formatter: function() {
                if (this.point.graphic.radius < 10) {
                  return
                }

                var changeHTML;
                if (this.point.priceChangePercentage24h > 0) {
                  changeHTML = `<span style=font-weight:700;">+${parseFloat(
                    this.point.priceChangePercentage24h
                  ).toFixed(2)}%</span>`;
                } else {
                  changeHTML = `<span style=font-weight:700;">${parseFloat(
                    this.point.priceChangePercentage24h
                  ).toFixed(2)}%</span>`;
                }
                var coinName = this.point.name.toUpperCase();
                var fontSize = this.point.graphic.radius / 4;

                return [
                  `<div>`,
                  `<div style="font-size:${fontSize}px">${coinName}</div>`,
                  `<div style="font-size:${fontSize}px">${changeHTML}</div>`,
                  "</div>"
                ].join("");
              }
            }
          }
        },
        series: [
          {
            name: bubbleChartData.top_100_positive.name,
            color: "green",
            data: bubbleChartData.top_100_positive.data
          },
          {
            name: bubbleChartData.top_100_negative.name,
            color: "red",
            data: bubbleChartData.top_100_negative.data
          }
        ]
      });
    });
  }
}
